module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap writeinvoice-wrap flex-column"
  }, [(_vm.load) ? _c('mu-infinite-scroll', {
    staticClass: "load",
    attrs: {
      "loading": _vm.load,
      "loadingText": "拼命加载中"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.load) ? _c('div', {
    staticClass: "flex-item"
  }, [_c('div', {
    staticClass: "invoice-box"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("\n        发票类型：\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "invoice-type-box"
  }, _vm._l((_vm.invoiceTypeList), function(typeItem) {
    return _c('mu-chip', {
      key: typeItem.value,
      staticClass: "demo-chip",
      class: [_vm.invoiceData.invoiceType == typeItem.value ? 'primary' : ''],
      on: {
        "click": function($event) {
          _vm.invoiceData.invoiceType = typeItem.value;
          _vm.invoiceData.invoiceTypeName = typeItem.name
        }
      }
    }, [_vm._v(_vm._s(typeItem.name))])
  }), 1)])]), _vm._v(" "), _c('div', {
    staticClass: "invoice-box"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("\n        发票抬头：\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "invoice-title-box"
  }, [_c('div', {
    staticClass: "radio-box"
  }, [_c('mu-radio', {
    staticClass: "list-radio",
    class: ['person' == _vm.invoiceTitle ? 'primary' : ''],
    attrs: {
      "nativeValue": "person",
      "label": "个人"
    },
    on: {
      "change": function($event) {
        _vm.invoiceData.invoiceHead = '个人';
        _vm.invoiceData.uniformCode = ''
      }
    },
    model: {
      value: (_vm.invoiceTitle),
      callback: function($$v) {
        _vm.invoiceTitle = $$v
      },
      expression: "invoiceTitle"
    }
  }), _vm._v(" "), _c('mu-radio', {
    staticClass: "list-radio",
    class: ['company' == _vm.invoiceTitle ? 'primary' : ''],
    attrs: {
      "nativeValue": "company",
      "label": "单位"
    },
    model: {
      value: (_vm.invoiceTitle),
      callback: function($$v) {
        _vm.invoiceTitle = $$v
      },
      expression: "invoiceTitle"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.invoiceTitle == 'company' && _vm.memInvoiceMsgList.length > 0),
      expression: "invoiceTitle=='company' && memInvoiceMsgList.length > 0"
    }],
    staticClass: "company-list"
  }, _vm._l((_vm.memInvoiceMsgList), function(item, index) {
    return _c('div', {
      staticClass: "company-item"
    }, [_c('p', {
      staticClass: "ellipsis floatL",
      on: {
        "click": function($event) {
          return _vm.selcompanycheckbox(index)
        }
      }
    }, [_vm._v(_vm._s(item.invoiceHead))]), _vm._v(" "), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isEditState),
        expression: "isEditState"
      }],
      staticClass: "edit-company fr"
    }, [_c('label', {
      staticClass: "primary",
      on: {
        "click": function($event) {
          return _vm.write('modify', index)
        }
      }
    }, [_vm._v("编辑")]), _vm._v(" "), _c('label', {
      staticClass: "primary",
      on: {
        "click": function($event) {
          return _vm.write('delete', index)
        }
      }
    }, [_vm._v("删除")])]), _vm._v(" "), _c('mu-radio', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.isEditState),
        expression: "!isEditState"
      }],
      staticClass: "list-radio fr",
      class: [item.invoiceHead == _vm.invoiceData.invoiceHead ? 'primary' : ''],
      attrs: {
        "nativeValue": item.invoiceHead
      },
      on: {
        "change": function($event) {
          _vm.invoiceData.invoiceHead = item.invoiceHead;
          _vm.invoiceData.uniformCode = item.uniformCode
        }
      },
      model: {
        value: (_vm.selectedCompanyid),
        callback: function($$v) {
          _vm.selectedCompanyid = $$v
        },
        expression: "selectedCompanyid"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "clear"
    })], 1)
  }), 0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.invoiceTitle == 'company' && _vm.memInvoiceMsgList.length <= 0) || (_vm.isAddState)),
      expression: "(invoiceTitle == 'company'  && memInvoiceMsgList.length <= 0) || (isAddState)"
    }],
    staticClass: "write-company"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addInfo.invoiceHead),
      expression: "addInfo.invoiceHead"
    }],
    attrs: {
      "type": "text",
      "placeholder": "新增单位发票抬头"
    },
    domProps: {
      "value": (_vm.addInfo.invoiceHead)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.addInfo, "invoiceHead", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addInfo.uniformCode),
      expression: "addInfo.uniformCode"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入纳税人识别号"
    },
    domProps: {
      "value": (_vm.addInfo.uniformCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.addInfo, "uniformCode", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.invoiceTitle == 'company'),
      expression: "invoiceTitle=='company'"
    }],
    staticClass: "operate"
  }, [_c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.memInvoiceMsgList.length > 0 && !_vm.isEditState && !_vm.isAddState),
      expression: "memInvoiceMsgList.length > 0 && !isEditState && !isAddState"
    }],
    staticClass: "blue",
    on: {
      "click": function($event) {
        return _vm.write('edit', null)
      }
    }
  }, [_vm._v("编辑单位")]), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.memInvoiceMsgList.length > 0 && !_vm.isEditState && !_vm.isAddState),
      expression: "memInvoiceMsgList.length > 0 && !isEditState && !isAddState"
    }],
    staticClass: "blue",
    on: {
      "click": function($event) {
        return _vm.write('add', null)
      }
    }
  }, [_vm._v("新增单位")]), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEditState && !_vm.isAddState),
      expression: "isEditState && !isAddState"
    }],
    staticClass: "blue",
    on: {
      "click": function($event) {
        return _vm.write('finish', null)
      }
    }
  }, [_vm._v("完成")]), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAddState && !_vm.isEditState),
      expression: "isAddState && !isEditState"
    }],
    staticClass: "blue",
    on: {
      "click": function($event) {
        return _vm.write('quit', null)
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.invoiceTitle == 'company' && _vm.memInvoiceMsgList.length <= 0 || _vm.isAddState) && !_vm.isEditState),
      expression: "(invoiceTitle == 'company' && memInvoiceMsgList.length <= 0 ||isAddState) && !isEditState"
    }],
    staticClass: "blue",
    on: {
      "click": function($event) {
        return _vm.write('save', null)
      }
    }
  }, [_vm._v("保存")])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "invoice-box"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("\n        发票内容：\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "invoice-content-box"
  }, [_c('div', {
    staticClass: "radio-box"
  }, _vm._l((_vm.invoiceContentList), function(item) {
    return _c('mu-radio', {
      key: item.value,
      staticClass: "list-radio",
      class: [item.value == _vm.invoiceData.invoiceContent ? 'primary' : ''],
      attrs: {
        "nativeValue": item.name,
        "label": item.name
      },
      on: {
        "change": function($event) {
          _vm.invoiceData.invoiceContent = item.value;
          _vm.invoiceData.invoiceContentName = item.name
        }
      },
      model: {
        value: (_vm.invoiceData.invoiceContentName),
        callback: function($$v) {
          _vm.$set(_vm.invoiceData, "invoiceContentName", $$v)
        },
        expression: "invoiceData.invoiceContentName"
      }
    })
  }), 1)])])])]) : _vm._e(), _vm._v(" "), (!_vm.load) ? _c('div', {
    staticClass: "bottom-btn-box"
  }, [_c('div', {
    staticClass: "bottom-full-button"
  }, [_c('mu-raised-button', {
    attrs: {
      "label": "确 定",
      "fullWidth": "",
      "primary": ""
    },
    on: {
      "click": _vm.submit
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('mu-dialog', {
    attrs: {
      "open": _vm.deleteDialog,
      "title": "删除单位",
      "titleClass": "dialogTitle",
      "bodyClass": "dialogBody",
      "actionsContainerClass": "dialogActionsContainer"
    },
    on: {
      "close": function($event) {
        _vm.deleteDialog = false
      }
    }
  }, [_vm._v("\n    确定删除这个单位吗？\n    "), _c('mu-flat-button', {
    attrs: {
      "slot": "actions",
      "primary": "",
      "label": "否"
    },
    on: {
      "click": function($event) {
        _vm.deleteDialog = false
      }
    },
    slot: "actions"
  }), _vm._v(" "), _c('mu-flat-button', {
    attrs: {
      "slot": "actions",
      "primary": "",
      "label": "确定"
    },
    on: {
      "click": _vm.deleteHead
    },
    slot: "actions"
  })], 1), _vm._v(" "), _c('mu-dialog', {
    attrs: {
      "open": _vm.editDialog,
      "bodyClass": "dialogBody input-dialog",
      "actionsContainerClass": "dialogActionsContainer"
    },
    on: {
      "close": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_c('div', {
    staticClass: "write-company"
  }, [_c('p', [_vm._v("单位发票抬头")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selCompany.invoiceHead),
      expression: "selCompany.invoiceHead"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入发票抬头"
    },
    domProps: {
      "value": (_vm.selCompany.invoiceHead)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selCompany, "invoiceHead", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', [_vm._v("纳税人识别号")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selCompany.uniformCode),
      expression: "selCompany.uniformCode"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入纳税人识别号"
    },
    domProps: {
      "value": (_vm.selCompany.uniformCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selCompany, "uniformCode", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('mu-flat-button', {
    attrs: {
      "slot": "actions",
      "primary": "",
      "label": "否"
    },
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    },
    slot: "actions"
  }), _vm._v(" "), _c('mu-flat-button', {
    attrs: {
      "slot": "actions",
      "primary": "",
      "label": "确定"
    },
    on: {
      "click": _vm.saveEdit
    },
    slot: "actions"
  })], 1), _vm._v(" "), (_vm.toast.toast) ? _c('mu-toast', {
    staticClass: "custom-toast",
    attrs: {
      "message": _vm.toast.messageTip
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-157001f4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/cart/writeinvoice.vue
// module id = 378
// module chunks = 68